// E3 Plus Constants
const e3PlusFunctions = [
  {
    label: 'Posição de LBS',
    name: 'lbs_position',
    data: [
      { label: 'Ligado', value: true },
      { label: 'Desligado', value: false },
    ],
  },
  {
    label: 'Atualização da posição em curva',
    name: 'cornering_position_update',
    data: [
      { label: 'Ligado', value: true },
      { label: 'Desligado', value: false },
    ],
  },
  {
    label: 'Alerta de ignição / Corte de alimentação (SMS)',
    name: 'ignition_alert_power_cut',
    data: [
      { label: 'Ligado', value: true },
      { label: 'Desligado', value: false },
    ],
  },
  {
    label: 'Alerta de falha de GPRS (SMS)',
    name: 'gprs_failure_alert',
    data: [
      { label: 'Ligado', value: true },
      { label: 'Desligado', value: false },
    ],
  },
  {
    label: 'Funcionamento dos LEDS',
    name: 'led',
    data: [
      { label: 'Ligado', value: true },
      { label: 'Desligado', value: false },
    ],
  },
  {
    label: 'Ignição Virtual',
    name: 'virtual_ignition',
    data: [
      { label: 'Ligado', value: true },
      { label: 'Desligado', value: false },
    ],
  },
];

const e3PlusOptionalFunctions = [
  {
    label: 'Modo de Operação',
    name: 'operation_mode',
    data: [
      { label: 'Ligado', value: true },
      { label: 'Desligado', value: false },
    ],
  },
];

// E3 Plus 4G and BWS 4G Constants
const e3Plus4GFunctions = [
  {
    label: 'Detecção de jammer',
    name: 'jammer_detection',
    data: [
      { label: 'Ligado', value: true },
      { label: 'Desligado', value: false },
    ],
  },
  {
    label: 'Anti-Furto',
    name: 'anti_theft',
    data: [
      { label: 'Ligado', value: true },
      { label: 'Desligado', value: false },
    ],
  },
  {
    label: 'Posição de LBS',
    name: 'lbs_position',
    data: [
      { label: 'Ligado', value: true },
      { label: 'Desligado', value: false },
    ],
  },
  {
    label: 'Funcionamento dos LEDS',
    name: 'led',
    data: [
      { label: 'Ligado', value: true },
      { label: 'Desligado', value: false },
    ],
  },
];

// BWS 4G Specific Functions
const bws4GFunctions = [
  {
    label: 'Detecção de jammer',
    name: 'jammer_detection',
    data: [
      { label: 'Ligado', value: true },
      { label: 'Desligado', value: false },
    ],
  },
  {
    label: 'Anti-Furto (Engine)',
    name: 'anti_theft',
    data: [
      { label: 'Ligado', value: true },
      { label: 'Desligado', value: false },
    ],
  },
  {
    label: 'SMS',
    name: 'sms',
    data: [
      { label: 'Habilitar', value: true },
      { label: 'Desabilitar', value: false },
    ],
  },
  {
    label: 'Posição de LBS',
    name: 'lbs_position',
    data: [
      { label: 'Ligado', value: true },
      { label: 'Desligado', value: false },
    ],
  },
  {
    label: 'Funcionamento dos LEDS',
    name: 'led',
    data: [
      { label: 'Ligado', value: true },
      { label: 'Desligado', value: false },
    ],
  },
  {
    label: 'Filtro de Velocidade GPS',
    name: 'gps_filter_speed',
    data: [
      { label: 'Habilitar - Filtra velocidades >0.9g', value: true },
      { label: 'Desabilitar - Não realiza filtro', value: false },
    ],
  },
  {
    label: 'GPS Periodic Wakeup',
    name: 'gps_periodic_wakeup',
    data: [
      { label: 'Habilitar - Ativar GPS a cada 15 minutos (Eco 1 e 2)', value: true },
      { label: 'Desabilitar - Ativa GPS apenas quando irá posicionar', value: false },
    ],
  },
  {
    label: 'Download AGPS',
    name: 'always_get_agps',
    data: [
      { label: 'Habilitar - Baixa o AGPS a cada vez que ignição é ligada', value: true },
      { label: 'Desabilitar - Baixa AGPS a cada 12 horas', value: false },
    ],
  },
];

const e3Plus4GOptionalFunctions = [
  {
    label: 'Limpar Buffer',
    name: 'clear_buffer',
    data: [
      { label: 'Ligado', value: true },
      { label: 'Desligado', value: false },
    ],
  },
  {
    label: 'Resetar Horímetro',
    name: 'clear_horimeter',
    data: [
      { label: 'Ligado', value: true },
      { label: 'Desligado', value: false },
    ],
  },
];

// Common Constants
const lockType = [
  { label: 'Progressivo', value: 1 },
  { label: 'Instantâneo', value: 2 },
  { label: 'Inverso', value: 3 },
];

const bws4GLockType = [
  { label: 'Padrão', value: 30 },
  { label: 'Inverso', value: 31 },
];

const lockTypeVariation = [
  { label: 'Progressivo', value: 1 },
  { label: 'Instantâneo', value: 2 },
];

const accelerometerSensitivity = [
  { value: 0, label: 0 },
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
  { value: 6, label: 6 },
  { value: 7, label: 7 },
  { value: 8, label: 8 },
  { value: 9, label: 9 },
  { value: 10, label: 10 },
];

const economyMode = [
  { value: 0, label: 'GPS Ligado (Em Sleep)' },
  { value: 1, label: 'GPS Desligado (Em Sleep)' },
];

const e3Plus4GEconomyMode = [
  { value: 0, label: 'Desligado' },
  { value: 1, label: 'Meia Economia' },
  { value: 2, label: 'Economia Máxima' },
];

const nb2EconomyMode = [
  { value: 0, label: 'Desligado' },
  { value: 1, label: 'Meia Economia' },
  { value: 2, label: 'Economia Máxima' },
];

const workMode = [
  { value: 'SLAVE', label: 'Botão de Pânico' },
  { value: 'MASTER', label: 'Ignição Física' },
  { value: 'NEGATIVE', label: 'Violação de módulo' },
];

const communicationType = [
  { value: 'TCP', label: 'TCP' },
  { value: 'UDP', label: 'UDP' },
];

const bws4GCommunicationType = [{ value: 'TCP', label: 'TCP' }];

const protocolType = [
  { value: 'E3+', label: 'E3' },
  { value: 'GT06', label: 'GT06' },
];

const bws4GProtocolType = [{ value: 'E3+', label: 'E3' }];

const bws4GNetworkMode = [
  { value: 'AUTO', label: 'Auto' },
  { value: '4G', label: '4G' },
  { value: '2G', label: '2G' },
];

const bws4GIgnitionType = [
  { value: 0, label: 'Automático' },
  { value: 1, label: 'Apenas ignição física' },
  { value: 2, label: 'Apenas ignição virtual' },
];

const jammerDetection = [
  { value: 0, label: 'Desligado' },
  { value: 1, label: 'Ligado' },
];

const input1 = [
  { value: 1, label: 'Ignição' },
  { value: 2, label: 'SOS' },
];

const input2 = [
  { value: 1, label: 'Monitora' },
  { value: 2, label: 'SOS' },
  { value: 3, label: 'Módulo' },
];

const nb2LockType = [
  { value: 1, label: 'Progressivo' },
  { value: 2, label: 'Instantâneo' },
  { value: 3, label: 'Inverso' },
  { value: 30, label: 'Padrão' },
  { value: 31, label: 'Inverso (NB-2)' },
];

export const configurationProfileConstants = {
  DM_E3_PLUS: {
    functions: e3PlusFunctions,
    optionalFunctions: e3PlusOptionalFunctions,
    lockType,
    accelerometerSensitivity,
    economyMode,
    workMode,
  },
  DM_E3_PLUS_4G: {
    functions: e3Plus4GFunctions,
    optionalFunctions: e3Plus4GOptionalFunctions,
    lockType,
    accelerometerSensitivity,
    economyMode: e3Plus4GEconomyMode,
    communicationType,
    protocolType,
    jammerDetection,
    input1,
    input2,
  },
  DM_BWS_4G: {
    functions: bws4GFunctions,
    optionalFunctions: e3Plus4GOptionalFunctions,
    lockType: bws4GLockType,
    lockTypeVariation,
    accelerometerSensitivity,
    economyMode: e3Plus4GEconomyMode,
    communicationType: bws4GCommunicationType,
    protocolType: bws4GProtocolType,
    networkMode: bws4GNetworkMode,
    ignitionType: bws4GIgnitionType,
    jammerDetection,
    input1,
    input2,
  },
  // Cópia do BWS 4G — vai divergir quando a parte LoRa for implementada
  DM_BWS_PLUS_4G_LORA: {
    functions: bws4GFunctions,
    optionalFunctions: e3Plus4GOptionalFunctions,
    lockType: bws4GLockType,
    lockTypeVariation,
    accelerometerSensitivity,
    economyMode: e3Plus4GEconomyMode,
    communicationType: bws4GCommunicationType,
    protocolType: bws4GProtocolType,
    networkMode: bws4GNetworkMode,
    ignitionType: bws4GIgnitionType,
    jammerDetection,
    input1,
    input2,
  },
  DM_BWS_NB2: {
    economyMode: nb2EconomyMode,
    lockType: nb2LockType,
  },
};
